'use client'

import React from 'react';
import { useEffect, useState } from "react";

interface ServiceItemProps {
    icon: React.ReactNode;
    title: string;
    text: string;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ icon, title, text }) => {

    const [bgImage, setBgImage] = useState("/bg/hero.png");
    
        useEffect(() => {
            const handleResize = () => {
                if (window.innerWidth <= 992) {
                    setBgImage("/bg/service-item-bg-mob.png");
                } else {
                    setBgImage("/bg/service-item-bg.svg");
                }
            };
    
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

    return (
        <div className="flex flex-col justify-end border-2 border-violet-50 bg-left-top bg-no-repeat rounded-[40px] p-8 pt-[90px] max-[576px]:p-[20px] max-[576px]:pt-[116px]  relative min-h-[360px] max-[992px]:min-h-[260px]  max-[576px]:rounded-[24px]"  style={{ backgroundImage: `url('${bgImage}')` }}>
            <div className="absolute left-[32px] top-[32px] max-[576px]:left-[20px] max-[576px]:top-[20px] ">
                {icon}
            </div>
            <h3 className="font-bold text-violet-500 text-[28px] leading-[129%] max-[992px]:text-[22px] max-[576px]:text-[20px]">
                {title}
            </h3>
            <p className="mt-[12px] text-base text-violet-300 leading-[125%] max-[576px]:mt-[8px] max-[576px]:text-[14px]">
                {text}
            </p>
        </div>
    )
}

export default ServiceItem